export const enum NftContentType {
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
    '3D' = '3d',
}

export interface NftContentTypeI {
    contentType: NftContentType;
}

export const getNftContentType = (contentType: string): NftContentType | null => {
    if (contentType.indexOf('image') === 0) {
        return NftContentType.IMAGE;
    }
    if (contentType.indexOf('video') === 0) {
        return NftContentType.VIDEO;
    }
    if (contentType.indexOf('audio') === 0) {
        return NftContentType.AUDIO;
    }
    if (contentType.includes('octet')) {
        return NftContentType['3D'];
    }

    return null;
};
